export default __webpack_public_path__ + "static/media/authentification.6705e0be.svg";